import React from 'react';
import PropTypes from 'prop-types';
import ReservationsShow from './ReservationsShow';
import authHelper from 'helpers/auth';
import utils from 'helpers/utils';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import { fetchReservation } from 'store/actions/reservations/fetchReservations';

class ReservationsShowContainer extends React.Component {
    componentDidMount() {
        const {
            fetchProductData,
            fetchReservationData,
            reservationId,
            product,
            record,
        } = this.props;

        if (utils.isEmpty(record)) {
            fetchReservationData(reservationId);
            return;
        }

        if (utils.isEmpty(product) && record.product_id) {
            fetchProductData(record.product_id);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            fetchProductData,
            fetchReservationData,
            reservationId,
            product,
            record,
        } = this.props;

        if (utils.isEmpty(product) && record.product_id) {
            fetchProductData(record.product_id);
        }

        if (reservationId !== prevProps.reservationId) {
            fetchReservationData(reservationId);
        }
    }

    render() {
        if (authHelper.isAnonymous() || authHelper.isReseller()) {
            return <Redirect to='/' />;
        }

        const { product, record, resource } = this.props;

        if (utils.isEmpty(record) || utils.isEmpty(product)) {
            return null;
        }

        return <ReservationsShow
            product={ product }
            record={ record }
            resource={ resource }
        />;
    }
}

ReservationsShowContainer.propTypes = {
    fetchProductData: PropTypes.func.isRequired,
    fetchReservationData: PropTypes.func.isRequired,
    reservationId: PropTypes.string,
    product: PropTypes.object,
    record: PropTypes.object,
    resource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, props) => {
    const { id } = props.match.params;

    let record = {};
    let product = {};

    if (state.reservations.data[id]) {
        record = state.reservations.data[id];
    }

    if (record) {
        product = state.products.data[record.product_id];
    }

    return {
        reservationId: id,
        product: product,
        record: record,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchReservationData: (id) => {
            dispatch(fetchReservation({
                id: id,
            }));
        },
        fetchProductData: (productId) => {
            dispatch(fetchProduct({
                id: productId,
            }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReservationsShowContainer);



// WEBPACK FOOTER //
// ./src/pages/reservations/show/ReservationsShowContainer.js